<div class="modal-content-frequency">
    <div class="grid grid-cols-2 py-4">
        <mat-form-field class="col-span-1" floatLabel="never">
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
              <input matStartDate formControlName="start" placeholder="Fecha Inicio">
              <input matEndDate formControlName="end" placeholder="Fecha Fin">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          
            @if (range.controls.start.hasError('matStartDateInvalid')) {
              <mat-error>Fecha inválida</mat-error>
            }
            @if (range.controls.end.hasError('matEndDateInvalid')) {
              <mat-error>Fecha inválida</mat-error>
            }
        </mat-form-field>
        <div class="flex justify-end w-full sm:w-auto">
            <button mat-raised-button color="primary" (click)="onSearch()">Filtrar</button>       
        </div>
    </div>
    <div class="flex-frequency">
        <div #flex1 class="flex-1">   
            <div *ngFor="let frequencyType of listAppointment;let isFirst = first"> 
                <mat-expansion-panel class="custom-expansion-panel" (opened)="isFirst;toggleExpand(frequencyType);" (closed)="isFirst;closeExpand(frequencyType)" hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="custom-indicator">
                                <mat-icon>{{ frequencyType.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                            </div>
                            {{ getAppointmentDate(frequencyType.date)}}
                        </mat-panel-title>
                        <mat-panel-description>
                           {{frequencyType.businessPartners?.length}}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    
                    <mat-expansion-panel-content>
                        <table mat-table #mainTable [id]="'table-' + frequencyType._id" [(dataSource)]="frequencyType.businessPartenerAppointmentList" class="min-w-500 overflow-y-visible mat-elevation-z"
                            cdkDropList #main="cdkDropList" [cdkDropListConnectedTo]="['client']" (cdkDropListDropped)="drop($event, frequencyType._id)" 
                            [cdkDropListData]="frequencyType.businessPartenerAppointmentList"  multiTemplateDataRows>
                            <ng-container matColumnDef="Nombre">
                                <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                <td mat-cell *matCellDef="let partner">
                                    {{ partner.businessPartner.name || "Sin nombre" }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Contacto">
                                <th mat-header-cell *matHeaderCellDef>Contacto</th>
                                <td mat-cell *matCellDef="let partner">
                                    {{ partner.businessPartner.principalContact?.fullName || "Sin contacto"}} <br>
                                    {{ partner.businessPartner.principalPhone?.phone || "Sin teléfono"}}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="['Nombre','Contacto',]"></tr>
                            <tr mat-row *matRowDef="let partner;columns: ['Nombre','Contacto']" cdkDrag [cdkDragData]="partner"></tr>
                        </table>
                        <div *ngIf="frequencyType.businessPartenerAppointmentList.length == 0" class="border-t p-8 text-center text-1xl tracking-tight sm:p-10">
                            No existen registros para visualizar.</div>
                    </mat-expansion-panel-content>
                </mat-expansion-panel>
            </div>
        </div>
    </div>
</div>